import React, { useState } from 'react';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Icon } from '@iconify/react';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import { useSnackbar } from 'notistack';

export default function DialogFormAction({ handleReembolso, text, evento }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <MenuItem onClick={() => setOpenDialog(true)}>{text}</MenuItem>
      {/* <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
        Abrir dialogo
      </Button> */}
      <DialogBody
        open={openDialog}
        onClose={setOpenDialog}
        handleReembolso={handleReembolso}
        text={text}
        evento={evento}
      />
    </>
  );
}

function DialogBody({ open, onClose, handleReembolso, text, evento }) {
  const { verifyUserNip } = useAuthUsers();
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    onClose(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset
  } = useForm();

  const onSubmit = async (dataForm) => {
    if (verifyUserNip(dataForm.nip)) {
      console.log(dataForm, text, evento);
      await handleReembolso(dataForm, evento);
      handleClose();
    } else {
      enqueueSnackbar('Ingrese su nip correcto.', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <Card sx={{ padding: '15px' }} component="form" onSubmit={handleSubmit(onSubmit)}>
          <Box marginBottom="15px">
            <TextField
              type="text"
              fullWidth
              {...register('message', { required: true })}
              variant="outlined"
              label="Mensaje"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su mensaje
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <LoadingButton loading={isSubmitting} fullWidth variant="contained" type="submit">
            Aceptar
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
